import styled from "@emotion/styled";

import { styleCss } from "components/layout/utils";

export const Item = styled.div`
  display: inline-block;
  font-size: 14px;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  ${styleCss("color")}
  vertical-align: middle;
`;
